import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            {aboutContent.title}
          </h2>
          <p className="text-sm text-foreground-500">了解国内领先的黑料吃瓜内容平台</p>
        </div>
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 space-y-5">
            {aboutContent.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
          <div className="flex-shrink-0 w-full max-w-md lg:max-w-[400px] aspect-[4/3] rounded-2xl overflow-hidden">
            <img
              src={aboutContent.image}
              alt="17黑料网编辑团队工作场景"
              className="w-full h-full object-cover"
              onError={(e) => {
                const target = e.currentTarget;
                target.style.display = 'none';
                if (target.parentElement) {
                  target.parentElement.style.display = 'none';
                }
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}